<template>
   <article class="article">
      <div class="intro-text-wrap">
         <span class="article-number adobe-clean-medium d-block text-center enter-anim">0{{ number }}</span>
         <h1 class="article-title knockout-lite text-uppercase enter-anim">
            <span class="article-title--highlighted" :style="{ color: color }">{{ title.highlightedText }}</span>
            <span class="article-title--normal">{{ title.normalText }}</span>
         </h1>
         <div class="text-spacer enter-anim" :style="{ color: color }"></div>
         <div class="intro-text enter-anim" v-html="introText"></div>
      </div>
      <div class="article-quotes enter-anim">
         <Quote
                 v-for="(quote, index) in quotes"
                 :quote="quote"
                 :key="quote.heading"
                 :index="index"
                 :activeQuoteIdx="activeQuoteIdx"
                 :article="article"
                 :quotesLength="quotes.length"
         >
         </Quote>
      </div>
      <div ref="articleEnd" class="article-end"></div>
   </article>
</template>

<script>
    import ScrollMagic from 'scrollmagic'
    import 'debug.addIndicators'

    import {bus, html, smController} from './../consts'

    import Quote from './Quote'
    import StageQuote from './StageQuote'

    export default {
        name: 'Article',
        components: {
            Quote, StageQuote
        },
        props: [
            'article',
            'index'
        ],
        data() {
            return {
                number: this.article.number,
                color: this.article.color,
                title: this.article.title,
                introText: this.article.paragraphText,
                featuredQuote: this.article.featuredQuote,
                quotes: this.article.quotes,
                activeQuoteIdx: 0,
                smController: new ScrollMagic.Controller(),
                mobileAnimation: new ScrollMagic.Scene(),
                articleEndScene: new ScrollMagic.Scene()
            }
        },
        methods: {
            handleReachedQuote(idx) {
                this.activeQuoteIdx = idx;
            },
            setScene() {
                this.articleEndScene
                    .triggerElement(this.$refs.articleEnd)
                    .on('start', (e) => {
                        if (this.$store.state.magicAllowed) {
                            if (e.scrollDirection === 'REVERSE') {
                                this.$store.commit('setActiveArticleIdx', this.index);
                                this.$store.commit('setPrevArticleIdx', this.index + 1);
                            } else if (e.scrollDirection === 'FORWARD') {
                                this.$store.commit('setActiveArticleIdx', this.index + 1);
                                this.$store.commit('setPrevArticleIdx', this.index);
                            }
                        }
                    })
                    .addTo(this.smController)
                    //.addIndicators({name: 'articleEnd', colorEnd: 'black'})
            }
        },
        mounted() {
            if (!this.$store.state.isPortrait) {
                this.setScene();
            } else {
                this.mobileAnimation
                    .triggerElement(this.$el)
                    .offset(-100)
                    .on('start', (e) => {
                        e.scrollDirection === 'FORWARD' ? this.$el.classList.add('mounted') : null;
                    })
                    .addTo(this.smController)
            }

            bus.$on('reachedQuote', this.handleReachedQuote);
        },
        beforeDestroy() {
            this.articleEndScene.destroy();
            bus.$off('reachedQuote', this.handleReachedQuote);
        }
    }
</script>

<style lang="scss" scoped>
   @import '../scss/the-goods';

   .article {
      width      : 100%;
      padding    : 0 $scroll-content-padding-right 0 $scroll-content-padding-left;
      background : $color-light-grey;

      @include screen-xs-sm {
         padding : 3rem 2.5rem;
      }

      .enter-anim {
         transition : opacity 0.5s $default-bez, transform 0.5s $default-bez;
      }

      .intro-text-wrap {

         @include screen-desktop {
            padding-top   : 12rem;
            margin-bottom : 12rem;
         }
      }

      &-number {
         font-size        : 2.1rem;
         margin-bottom    : 1.5rem;
         max-width        : $scroll-content-wrap-width;
         transition-delay : 0.1s !important;

         @include screen-xs-sm {
            font-size     : 1.5rem;
            margin-bottom : 2rem;
            line-height   : 1;
         }
      }

      &-title {
         font-size        : 6.4rem;
         line-height      : 1;
         margin-bottom    : 2.6rem;
         transition-delay : 0.2s !important;

         @include screen-xs-sm {
            font-size     : 4rem;
            line-height   : 3.8rem;
            margin-bottom : 2.1rem;
         }

         @include screen-xxl {
            font-size : 7.4rem;
         }
         @include screen-xs-sm {
            font-size : 3.5rem;
         }
      }

      .text-spacer {
         transition-delay : 0.3s !important;
      }

      .intro-text {
         transition-delay : 0.4s !important;

         @include screen-xs-sm {
            padding : 2rem 0 0 0;
         }
      }

      &-quotes {
         position         : relative;
         padding-bottom   : 375px; //allow enough distance for the last quote in the article to transform back and un-pin
         transition-delay : 0.6s !important;

         @include screen-xs-sm {
            padding-bottom : 100px;
         }
      }
   }

   #section-5 {
      .article-quotes {
         padding-bottom: 75vh;
      }
   }

   .article-quotes-leave-active {
      transition : transform 0.5s ease-out, opacity 0.5s ease-out;
   }

   .article-quotes-leave {
      transform : translateY(0);
      opacity   : 1;
   }

   .article-quotes-leave-to {
      transform : translateY(100vh);
      opacity   : 0;
   }

   .portrait-mode {
      .article {
         padding : 25px;

         &-quotes {
            padding-bottom : 150px;
         }
      }
   }
</style>



// WEBPACK FOOTER //
// src/components/Article.vue